import { toast } from "react-toastify";

export default function ConfirmDialog({
  open,
  onClose,
  apiFn,
  yesLabel = "Yes",
  onSuccess
}) {
  if (!open) return null;

  const handleYes = async () => {
    try {
      await apiFn();
      //toast.success(onSuccessMessage);
      onSuccess?.();
      onClose();
    } catch (e) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div style={overlay}>
      <div style={dialog}>
        <p>Are you sure?</p>

        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleYes}>{yesLabel}</button>
        </div>
      </div>
    </div>
  );
}

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const dialog = {
  background: "#fff",
  padding: 16,
  borderRadius: 6,
};
